import React, { useState, useEffect, useContext, useCallback } from 'react';

import './CharsheetMobile.css'

import { UserDataContext } from "../../App.js";

import FlexiGrid2 from '../common/Flexigrid2/Flexigrid2.js';

import LoadSaveButton from './MobileLoadSaveButton.js';
import Spellbook from '../Spell/Spellbook.jsx'
import CharNameMobile from '../CharNameMobile.js'

import unflatten from '../../components/Charsheet0/helpers/unflatten.js';
import { toggleEdit } from '../../helpers/toggleEdit.js'
import getAllowedClasses from '../../helpers/getAllowedClasses.js';
import { assignClickListeners } from '../../helpers/assignClickListeners.js'

import weaponGrandTotalImage from '../../assets/img/grand-total-2.png';

import sample_data_flat from '../../components/Charsheet0/helpers/sample_data_flat.js'


// ----------------------------------------------------------------------------------
//                         Description
//
//     CharsheetMobile is intended as the main html page for mobile
//
//     It will have a mobile header, a character section, and a details section
//
//     flatten.js has the text field names
//
//     (c) DXA Development 2024
// ----------------------------------------------------------------------------------

function CharsheetMobile(props) {


    // ------------ parameters ---------------
    let startData = sample_data_flat
    const INITIAL_MOBILE_SCROLL = 0; // 262;

    // ------ inherited state variables ------
    const [userData, setUserData] = useContext(UserDataContext);
    const [ tempCharData, setTempCharData ] = props.tempCharDataArray;
    const [ activeView, setActiveView ] = props.activeViewArray;

    const globalState = props.state;  

    var currentChar = props.state[0];
    var setChar = props.state[1];

    const [ currentSpell, setCurrentSpell] = props.state[5]
    const [ currentSpellData, setCurrentSpellData ] = props.state[6];

    const spellCheckArray = props.spellCheckArray;

    console.log('CHARSHEET MOBILE:', currentChar)

    const data = props.data;
    const setData = props.setdata;

    var spellUpdaters = props.spellUpdaters;
    spellUpdaters = [setCurrentSpell, setCurrentSpellData]

    // charID is used to ID the main div, which will be id="{charID}-div"
    const thisCharID = props.charID || '0'

    // -------- local state variables --------
    
    var [ charImage, setCharImage ] = useState( process.env.PUBLIC_URL + `/img/char/${userData.currentCampaign}/` + currentChar + '.jpg' );
    const [ editing, setEditing ] = useState(false);
    const [ allowedClasses, setAllowedClasses] = useState(['Fighter','Cleric', 'Magic-User', 'Thief'])
    const [ allowedRaces, setAllowedRaces] = useState(['Human','Elf', 'Half-Elf', 'Dwarf','Halfling','Gnome','Half-Orc'])
    const [ collapsed, setCollapsed ] = useState(false);
    const [ isDirty, setIsDirty ] = useState(false);

    const handleDataChange = useCallback((newData) => {
        setData(newData);
        setIsDirty(true);
    }, [setData]);
    
    const [ firstLoad, setFirstLoad ] = useState(true);
    const [ loadedChar, setLoadedChar ] = useState(currentChar);


    // ------------- event handlers ---------------

    // what happens when you click on a Spell Button (Spell1, ...)     
const handleSpellButtonClick = useCallback(() => {
  setEditing((prevEditing) => {
        console.log('Current tempCharData:', tempCharData); // Debugging log
        toggleEdit({
            editing: prevEditing,
            setEditing,
            tempCharData,
            setTempCharData,
            setData,
            data,
        });

        return !prevEditing;
  });
}, [tempCharData, setEditing, setTempCharData, setData, data]);


const validLevels = ['1','2','3','4','5','6','7','8','9','10','11','12']


const checkStatChanges = (newData) => {
    console.log('newData received:', newData);
        toggleEdit({ editing, setEditing, tempCharData, setTempCharData, setData, data: newData},'true')
    }


const toggleCollapse = () => setCollapsed(prev => !prev);

    // ------------- useEffects ---------------

    useEffect( () => {

        async function RefreshCharacter () {  

            console.log('CharsheetMobile UPDATE ', data )

            // if this is a new character load, then scroll to the Combat section
            if ( firstLoad || ( currentChar !== loadedChar ) ) {
              var scrollableDiv = document.getElementById("charsheet-scroll");
              scrollableDiv.scrollTop = INITIAL_MOBILE_SCROLL;
              setFirstLoad(false);
            }

            console.log('CS MOBILE User Data', userData )
        
            setCharImage( process.env.PUBLIC_URL + `/img/char/${userData.currentCampaign}/${currentChar}.jpg` );

            setLoadedChar( currentChar );

            console.log('mobile data', tempCharData )
            
        }

        RefreshCharacter();

        const classList = getAllowedClasses(data)
        console.log('allowed classes: ', classList)
        setAllowedClasses(classList)

        if (! editing ) { setTempCharData(unflatten(data))}       

    }, [ data, currentChar, userData.currentCampaign ]) ; //useEffect

    useEffect( () => { setIsDirty(false); }, [ currentChar ]);

    /* part of ADM1-275 that is getting shelved
    useEffect( () => {

        // setTempCharData( data.chardata )
        
        // assignClickListeners( handleSpellButtonClick )
        
    }, [ ]);
    */




    // -----------------------------------------------------
    //           DEFINE THE GRID
    // -----------------------------------------------------

    const spellOptions = {'spellUpdaters': spellUpdaters, 'handleClick': handleSpellButtonClick, draggable: true }

    const StatStart = 8;
    const ACyStart = 16;
    const WeapyStart = 22;
    const SavyStart = 28;
    
    const PotStart = 32;
    const MagStart = PotStart+7;
    const OthStart = 45;
    const FollowerStart = 53;
    const SpellStart = 66;

    // most common cell - implemented as input boxes
    const cells_layout_main = { 
      // name:       [1, 7, 1, 2],

      ClassTxt:   [1, 3, 2, 3],  /* myClass:    [3, 7, 2, 3], */
      LvlTxt:     [1, 3, 3, 4],  /* myLevel:    [2, 5, 3, 4],*/
      myXPbonus: [5,7,3,4], 
      XPTxt:      [7, 9, 2, 3],  myXP:       [7, 9, 3, 4],
      NXPTxt:     [7, 9, 4, 5],  myXPnext:   [7, 9, 5, 6],
      GoldTxt:    [7, 9, 6, 7],  myGold:     [7, 9, 7, 8],
      RaceTxt:    [1, 3, 4, 5],  /*myRace:     [3, 5, 4, 5],*/
      AliTxt:     [1, 3, 5, 6],  myAlign:    [3, 4, 5, 6],
      DeiTxt:     [5, 7, 4, 5],  myDeity:    [5, 7, 5, 6],
      AgeTxt:     [5, 7, 6, 7],  myAge:      [5, 7, 7, 8],

      StrTxt:     [1,2,StatStart,StatStart+1],  myStr:      [2, 4, StatStart,StatStart+1],  myStrBon:   [4, 5, StatStart,StatStart+1],
      IntTxt:     [1,2,StatStart+1,StatStart+2],  myInt:      [2, 4, StatStart+1,StatStart+2],  myIntBon:   [4, 5, StatStart+1,StatStart+2],
      WisTxt:     [1,2,StatStart+2,StatStart+3],  myWis:      [2, 4, StatStart+2,StatStart+3],  myWisBon:   [4, 5, StatStart+2,StatStart+3],
      DexTxt:     [5,6,StatStart,StatStart+1],  myDex:     [6, 8, StatStart,StatStart+1],  myDexBon:   [8, 9, StatStart,StatStart+1],
      ConTxt:     [5,6,StatStart+1,StatStart+2],  myCon:      [6, 8, StatStart+1,StatStart+2],  myConBon:   [8, 9, StatStart+1,StatStart+2],
      ChaTxt:     [5,6,StatStart+2,StatStart+3],  myCha:      [6, 8, StatStart+2,StatStart+3],  myChaBon:   [8, 9, StatStart+2,StatStart+3],

      // StatBuffer: [1,9,StatStart+3,StatStart+4],
      

      MovTxt:     [1, 3, 14, 15],  myMov:     [1, 3, 15, 16 ],
      HeiTxt:     [1, 3, 6, 7 ],   myHei:      [3, 5, 6 , 7 ], 
      WeiTxt:     [1, 3, 7, 8 ],   myWei:      [3, 5, 7, 8 ],
      
      HPTxt:      [7, 9, 12, 13], myHPbase:  [6, 9, 14, 15],
      myHPcurr:   [7, 9, 13, 14], myHPnote:  [6, 9, 15, 16],
      ACTxt:      [1, 2, 12, 13], myAC:      [2, 4, 12, 14],
      BaseTxt:    [4, 5, 12, 13], myRear:    [5, 7, 12, 13],
      RearTxt:    [4, 5, 13, 14], mySide:    [5, 7, 13, 14],
      ToHitTxt:   [3, 4, 15, 16], myToHit:   [4, 6, 15, 16],
      NattTxt:    [3, 4, 14, 15], myNatt:    [4, 6, 14, 15],
      
      // myBaseAC:   [8, 9, ACyStart, ACyStart+1], 
      myAb1:      [8, 9, ACyStart+1, ACyStart+2],
      myAb2:      [8, 9, ACyStart+2, ACyStart+3], 
      myAb3:      [8, 9, ACyStart+3, ACyStart+4], 
      myAb4:      [8, 9, ACyStart+4, ACyStart+5], 
      myAb5:      [8, 9, ACyStart+5, ACyStart+6], 

      WthTxt: [5, 6, WeapyStart, WeapyStart+1],    WdbTxt: [8, 9, WeapyStart, WeapyStart+1],   WdgTxt:  [6 ,8, WeapyStart, WeapyStart+1],
      myWth1: [5, 6, WeapyStart+1, WeapyStart+2], myWdb1: [8, 9, WeapyStart+1, WeapyStart+2], myWdmg1: [6 ,8, WeapyStart+1, WeapyStart+2],
      myWth2: [5, 6, WeapyStart+2, WeapyStart+3], myWdb2: [8, 9, WeapyStart+2, WeapyStart+3], myWdmg2: [6 ,8, WeapyStart+2, WeapyStart+3],
      myWth3: [5, 6, WeapyStart+3, WeapyStart+4], myWdb3: [8, 9, WeapyStart+3, WeapyStart+4], myWdmg3: [6 ,8, WeapyStart+3, WeapyStart+4],
      myWth4: [5, 6, WeapyStart+4, WeapyStart+5], myWdb4: [8, 9, WeapyStart+4, WeapyStart+5], myWdmg4: [6 ,8, WeapyStart+4, WeapyStart+5],
      myWth5: [5, 6, WeapyStart+5, WeapyStart+6], myWdb5: [8, 9, WeapyStart+5, WeapyStart+6], myWdmg5: [6 ,8, WeapyStart+5, WeapyStart+6],

      myQpo1:     [8, 9, 33, 34],
      myQpo2:     [8, 9, 34, 35], 
      myQpo3:     [8, 9, 35, 36], 
      myQpo4:     [8, 9, 36, 37], 
      myQpo5:     [8, 9, 37, 38], 
      myQpo6:     [8, 9, 38, 39], 

      FolTxt: [1, 9, FollowerStart+0, FollowerStart+1], myFol1: [1, 9, FollowerStart+1, FollowerStart+2], myFol2: [1, 9, FollowerStart+2, FollowerStart+3],
      RacTxt: [7, 9, SpellStart-8, SpellStart-7], myRabi: [1, 9, SpellStart-8, SpellStart-1],

      SaveTxt: [1, 9, SavyStart, SavyStart+1], SavTxt1: [1, 2, SavyStart+1, SavyStart+2], mySav1: [2, 3, SavyStart+1, SavyStart+2], mySbon1: [3, 4, SavyStart+1, SavyStart+2], SavTxt2: [1, 2, SavyStart+2, SavyStart+3], mySav2: [2, 3, SavyStart+2, SavyStart+3], mySbon2: [3, 4, SavyStart+2, SavyStart+3], 
      SavTxt3: [1, 2, SavyStart+3, SavyStart+4], mySav3: [2, 3, SavyStart+3, SavyStart+4], mySbon3: [3, 4, SavyStart+3, SavyStart+4], 
      SavTxt4: [5, 6, SavyStart+1, SavyStart+2], mySav4: [6, 7, SavyStart+1, SavyStart+2], mySbon4: [7, 8, SavyStart+1, SavyStart+2], 
      SavTxt5: [5, 6, SavyStart+2, SavyStart+3], mySav5: [6, 7, SavyStart+2, SavyStart+3], mySbon5: [7,8, SavyStart+2, SavyStart+3], 
      SavTxt6F: [5, 6, SavyStart+3, SavyStart+4], mySbon6: [6, 9, SavyStart+3, SavyStart+4], mySbon7: [8, 9, SavyStart, SavyStart+1],

      myTsp1: [3, 4, SpellStart+0, SpellStart+1], myNsp1: [4, 5,SpellStart+0, SpellStart+1],
      myTsp2: [7, 8, SpellStart+0, SpellStart+1], myNsp2: [8, 9, SpellStart+0, SpellStart+1], 
      myTsp3: [3, 4, SpellStart+11, SpellStart+12], myNsp3: [4, 5, SpellStart+11, SpellStart+12], myTsp4: [7, 8, SpellStart+11, SpellStart+12], myNsp4: [8, 9, SpellStart+11, SpellStart+12], 
      myTsp5: [3, 4, SpellStart+22, SpellStart+23], myNsp5: [4, 5, SpellStart+22, SpellStart+23],

      AbiTxt: [5, 9, SpellStart+22, SpellStart+23], myAbi: [5,9, SpellStart+23, SpellStart+28]

      
  };

    // ---------- HTML CELLS ----------
    const cells_html = [ 

        // {'name': 'html-test', 'coords': [7,9,4,5], 'code': 'HI MOM' },
        // {'name': 'char-image-mobile', 'coords': [7,9,1,2], 'type': 'img', 'options': {'source': charImage }},

        //{'name': 'gTotImg', 'coords': [5, 6, WeapyStart-1, WeapyStart+1], 'type': 'img', 'options': {'source': weaponGrandTotalImage }},
        
        {'name': 'Attributes', 'coords': [1,9,1,2], 'type': 'spellButton', 'options': {} },
        {'name': 'myClass', 'coords': [3, 7, 2, 3], 'type': 'restricted-text-box', 'options': { 'list': allowedClasses, 'action': checkStatChanges } },
        {'name': 'myLevel', 'coords': [3, 5, 3, 4], 'type': 'restricted-text-box', 'options': { 'list': validLevels, 'action': checkStatChanges } },
        {'name': 'myRace', 'coords': [3, 5, 4, 5], 'type': 'restricted-text-box', 'options': { 'list': allowedRaces, 'action': checkStatChanges } },

        {'name': 'CombatHeader', 'coords': [1,9,StatStart+3,StatStart+4], 'type': 'spellButton', 'options': {} },


        {'name': 'myAC', 'coords': [8, 9, ACyStart, ACyStart+1], 'type': 'input', 'options': {"class": "mobile-header-value" } },
        {'name': 'ArmTxt', 'coords': [1, 8, ACyStart, ACyStart+1], 'type': 'spellButton', 'options': {} },
        {'name': 'myArm1', 'coords': [1, 8, ACyStart+1, ACyStart+2], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myArm2', 'coords': [1, 8, ACyStart+2, ACyStart+3], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myArm3', 'coords': [1, 8, ACyStart+3, ACyStart+4], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myArm4', 'coords': [1, 8, ACyStart+4, ACyStart+5], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myArm5', 'coords': [1, 8, ACyStart+5, ACyStart+6], 'type': 'editableLink-item', 'options': spellOptions },

        {'name': 'myHPcurr', 'coords': [8, 9, StatStart+3,StatStart+4], 'type': 'input', 'options': {"class": "mobile-header-value" } },
        {'name': 'HPTxt', 'coords': [7, 8, StatStart+3,StatStart+4], 'type': 'input', 'options': "" },

        // Collapse Buttons
        {'name': 'AttXbut', 'coords': [1, 2, 1, 2], 'type': 'collapseButton', 'options': {}  },
        {'name': 'ComXbut', 'coords': [1, 2, StatStart+3,StatStart+4], 'type': 'collapseButton', 'options': {}  },
        {'name': 'WeaXbut', 'coords': [1, 2, WeapyStart, WeapyStart+1], 'type': 'collapseButton', 'options': {}  },
        {'name': 'SavXbut', 'coords': [1, 2, SavyStart, SavyStart+1], 'type': 'collapseButton', 'options': {}  },
        {'name': 'ArmXbut', 'coords': [1, 2, ACyStart, ACyStart+1], 'type': 'collapseButton', 'options': {}  },
        {'name': 'PotXbut', 'coords': [1, 2, PotStart, PotStart+1], 'type': 'collapseButton', 'options': {}  },
        {'name': 'MagXbut', 'coords': [1, 2, MagStart, MagStart+1], 'type': 'collapseButton', 'options': {}  },
        {'name': 'OthXbut', 'coords': [1, 2, OthStart, OthStart+1], 'type': 'collapseButton', 'options': {}  },
        {'name': 'FolXbut', 'coords': [1, 2, FollowerStart, FollowerStart+1], 'type': 'collapseButton', 'options': {}  },
        {'name': 'SpeXbut', 'coords': [1, 2, SpellStart-1, SpellStart], 'type': 'collapseButton', 'options': {}  },
        
        // special lines for mobile weapons headers
        {'name': 'myWth1', 'coords': [5, 6, WeapyStart, WeapyStart+2], 'type': 'input', 'options': {"class": "mobile-header-value" } },
        {'name': 'myWdb1', 'coords': [8, 9, WeapyStart, WeapyStart+2], 'type': 'input', 'options': {"class": "mobile-header-value" } },
        {'name': 'myWdmg1', 'coords': [6, 8, WeapyStart, WeapyStart+2], 'type': 'input', 'options': {"class": "mobile-header-value" } },

        {'name': 'WeaTxt', 'coords': [2, 5, WeapyStart, WeapyStart+1], 'type': 'spellButton', 'options': {}  },
        {'name': 'myWeap1', 'coords': [1, 5, WeapyStart+1, WeapyStart+2], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myWeap2', 'coords': [1, 5, WeapyStart+2, WeapyStart+3], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myWeap3', 'coords': [1, 5, WeapyStart+3, WeapyStart+4], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myWeap4', 'coords': [1, 5, WeapyStart+4, WeapyStart+5], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myWeap5', 'coords': [1, 5, WeapyStart+5, WeapyStart+6], 'type': 'editableLink-item', 'options': spellOptions },

        {'name': 'PotTxt', 'coords': [1, 9, 32, 33], 'type': 'spellButton', 'options': {} },
        {'name': 'myPot1', 'coords': [1, 8, 33, 34], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myPot2', 'coords': [1, 8, 34, 35], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myPot3', 'coords': [1, 8, 35, 36], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myPot4', 'coords': [1, 8, 36, 37], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myPot5', 'coords': [1, 8, 37, 38], 'type': 'editableLink-item', 'options': spellOptions },       
        {'name': 'myPot6', 'coords': [1, 8, 38, 39], 'type': 'editableLink-item', 'options': spellOptions },  

        {'name': 'MagTxt', 'coords': [1, 9, 39, 40], 'type': 'spellButton', 'options': {} },
        {'name': 'myMag1', 'coords': [1, 9, 40, 41], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myMag2', 'coords': [1, 9, 41, 42], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myMag3', 'coords': [1, 9, 42, 43], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myMag4', 'coords': [1, 9, 43, 44], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myMag5', 'coords': [1, 9, 44, 45], 'type': 'editableLink-item', 'options': spellOptions },

        {'name': 'OthTxt', 'coords': [1, 9, OthStart+0, OthStart+1], 'type': 'spellButton', 'options': {} },
        {'name': 'myOth1', 'coords': [1, 9, OthStart+1, OthStart+2], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myOth2', 'coords': [1, 9, OthStart+2, OthStart+3], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myOth3', 'coords': [1, 9, OthStart+3, OthStart+4], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myOth4', 'coords': [1, 9, OthStart+4, OthStart+5], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myOth5', 'coords': [1, 9, OthStart+5, OthStart+6], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myOth6', 'coords': [1, 9, OthStart+6, OthStart+7], 'type': 'editableLink-item', 'options': spellOptions },
        {'name': 'myOth7', 'coords': [1, 9, OthStart+7, OthStart+8], 'type': 'editableLink-item', 'options': spellOptions },

        {'name': 'SpellHeader', 'coords': [1,9,SpellStart-1, SpellStart], 'type': 'spellButton', 'options': {} },
        {'name': 'Sp1Txt', 'coords': [1, 3, SpellStart+0, SpellStart+1], 'type': 'spellButton', 'options': {} },
        {'name': 'Sp2Txt', 'coords': [5, 7, SpellStart+0, SpellStart+1], 'type': 'spellButton', 'options': {} },
        {'name': 'Sp3Txt', 'coords': [1, 3, SpellStart+11, SpellStart+12], 'type': 'spellButton', 'options': {} },
        {'name': 'Sp4Txt', 'coords': [5, 7, SpellStart+11, SpellStart+12], 'type': 'spellButton', 'options': {} },
        {'name': 'Sp5Txt', 'coords': [1, 3, SpellStart+22, SpellStart+23], 'type': 'spellButton', 'options': {} },
      
        {'name': 'mySp101', 'coords': [1, 5, SpellStart+1, SpellStart+2], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp102', 'coords': [1, 5, SpellStart+2, SpellStart+3], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp103', 'coords': [1, 5, SpellStart+3, SpellStart+4], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp104', 'coords': [1, 5, SpellStart+4, SpellStart+5], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp105', 'coords': [1, 5, SpellStart+5, SpellStart+6], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp106', 'coords': [1, 5, SpellStart+6, SpellStart+7], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp107', 'coords': [1, 5, SpellStart+7, SpellStart+8], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp108', 'coords': [1, 5, SpellStart+8, SpellStart+9], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp109', 'coords': [1, 5, SpellStart+9, SpellStart+10], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp110', 'coords': [1, 5, SpellStart+10, SpellStart+11], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },

        {'name': 'mySp201', 'coords': [5, 9, SpellStart+1, SpellStart+2], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp202', 'coords': [5, 9, SpellStart+2, SpellStart+3], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp203', 'coords': [5, 9, SpellStart+3, SpellStart+4], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp204', 'coords': [5, 9, SpellStart+4, SpellStart+5], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp205', 'coords': [5, 9, SpellStart+5, SpellStart+6], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp206', 'coords': [5, 9, SpellStart+6, SpellStart+7], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp207', 'coords': [5, 9, SpellStart+7, SpellStart+8], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp208', 'coords': [5, 9, SpellStart+8, SpellStart+9], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp209', 'coords': [5, 9, SpellStart+9, SpellStart+10], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp210', 'coords': [5, 9, SpellStart+10, SpellStart+11], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },

        {'name': 'mySp301', 'coords': [1, 5, SpellStart+12, SpellStart+13], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp302', 'coords': [1, 5, SpellStart+13, SpellStart+14], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp303', 'coords': [1, 5, SpellStart+14, SpellStart+15], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp304', 'coords': [1, 5, SpellStart+15, SpellStart+16], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp305', 'coords': [1, 5, SpellStart+16, SpellStart+17], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp306', 'coords': [1, 5, SpellStart+17, SpellStart+18], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp307', 'coords': [1, 5, SpellStart+18, SpellStart+19], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp308', 'coords': [1, 5, SpellStart+19, SpellStart+20], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp309', 'coords': [1, 5, SpellStart+20, SpellStart+21], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp310', 'coords': [1, 5, SpellStart+21, SpellStart+22], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },

        {'name': 'mySp401', 'coords': [5, 9, SpellStart+12, SpellStart+13], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp402', 'coords': [5, 9, SpellStart+13, SpellStart+14], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp403', 'coords': [5, 9, SpellStart+14, SpellStart+15], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp404', 'coords': [5, 9, SpellStart+15, SpellStart+16], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp405', 'coords': [5, 9, SpellStart+16, SpellStart+17], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp406', 'coords': [5, 9, SpellStart+17, SpellStart+18], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp407', 'coords': [5, 9, SpellStart+18, SpellStart+19], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp408', 'coords': [5, 9, SpellStart+19, SpellStart+20], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp409', 'coords': [5, 9, SpellStart+20, SpellStart+21], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp410', 'coords': [5, 9, SpellStart+21, SpellStart+22], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },

        {'name': 'mySp501', 'coords': [1, 5, SpellStart+23, SpellStart+24], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp502', 'coords': [1, 5, SpellStart+24, SpellStart+25], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp503', 'coords': [1, 5, SpellStart+25, SpellStart+26], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
        {'name': 'mySp504', 'coords': [1, 5, SpellStart+26, SpellStart+27], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },            
        {'name': 'mySp505', 'coords': [1, 5 ,SpellStart+27, SpellStart+28], 'type': 'editableLink-spell', 'options': spellOptions, 'spellChecks': spellCheckArray },
    ]

    // define the box structure
    const boxez = () => {
        
        const boxes_main = {  }

        var boxes_temp =  {
            // ...boxes_main = boxName: [1,21,1,2 ], boxStats: [1,8,2,8], boxStats2: [8,14,2,8], boxStats3: [14,21,2,8],


            boxAttHeader: [1,9,1,2], boxArmHeader: [1,9,ACyStart,ACyStart+1], //boxWeaHeader: [1,9,WeapyStart-1,WeapyStart],
            boxClas: [1,7,2,4],
            boxRace: [1,7,4,6], boxGld: [7,9,4,6],  
            boxHei:  [1,5,6,8], boxNXP:  [5,7,6,8],boxXP:  [7,9,6,8], 

            boxStrA: [1,2,StatStart,StatStart+1], boxStrB: [2,4,StatStart,StatStart+1], boxStrC: [4,5,StatStart,StatStart+1],
            boxIntA: [1,2,StatStart+1,StatStart+2], boxIntB: [2,4,StatStart+1,StatStart+2], boxIntC: [4,5,StatStart+1,StatStart+2],
            boxWisA: [1,2,StatStart+2,StatStart+3], boxWisB: [2,4,StatStart+2,StatStart+3], boxWisC: [4,5,StatStart+2,StatStart+3],
            boxDexA: [5,6,StatStart,StatStart+1], boxDexB: [6,8,StatStart,StatStart+1], boxDexC: [8,9,StatStart,StatStart+1],
            boxConA: [5,6,StatStart+1,StatStart+2], boxConB: [6,8,StatStart+1,StatStart+2], boxConC: [8,9,StatStart+1,StatStart+2],
            boxChaA: [5,6,StatStart+2,StatStart+3], boxChaB: [6,8,StatStart+2,StatStart+3], boxChaC: [8,9,StatStart+2,StatStart+3],
            
            boxHP:   [7,9,12,14],
            boxAC:   [1,4,12,14], boxACb: [4,7,12,14],
            boxToHit: [3,6,14,16], boxMov: [1,3,14,16],
            
            boxAC1: [8, 9, ACyStart, ACyStart+1], boxAC2: [8, 9, ACyStart+1, ACyStart+2], boxAC3: [8, 9, ACyStart+2, ACyStart+3], boxAC4: [8, 9, ACyStart+3, ACyStart+4], boxAC5: [8, 9, ACyStart+4, ACyStart+5], boxAC6: [8, 9, ACyStart+5, ACyStart+6],

            boxArmTxt: [1, 8, ACyStart, ACyStart+1], boxArm2: [1, 8, ACyStart+1, ACyStart+2], boxArm3: [1, 8, ACyStart+2, ACyStart+3], boxArm4: [1, 8, ACyStart+3, ACyStart+4], boxArm5: [1, 8, ACyStart+4, ACyStart+5], boxArm6: [1, 8, ACyStart+5, ACyStart+6],

            boxWeaTxt: [1, 5, WeapyStart, WeapyStart+1], boxWea2: [1, 5, WeapyStart+1, WeapyStart+2], boxWea3: [1, 5, WeapyStart+2, WeapyStart+3], 
            boxWea4: [1, 5, WeapyStart+3, WeapyStart+4], boxWea5: [1, 5, WeapyStart+4, WeapyStart+5], boxWea6: [1, 5, WeapyStart+5, WeapyStart+6],
            boxWthTxt: [5, 6, WeapyStart, WeapyStart+1], boxWth2: [5, 6, WeapyStart+1, WeapyStart+2], boxWth3: [5, 6, WeapyStart+2, WeapyStart+3], 
            boxWth4: [5, 6, WeapyStart+3, WeapyStart+4], boxWth5: [5, 6, WeapyStart+4, WeapyStart+5], boxWth6: [5, 6, WeapyStart+5, WeapyStart+6],
            boxWdbTxt: [8, 9, WeapyStart, WeapyStart+1], boxWdb2: [8, 9, WeapyStart+1, WeapyStart+2], boxWdb3: [8, 9, WeapyStart+2, WeapyStart+3], 
            boxWdb4: [8, 9, WeapyStart+3, WeapyStart+4], boxWdb5: [8, 9, WeapyStart+4, WeapyStart+5], boxWdb6: [8, 9, WeapyStart+5, WeapyStart+6],
            boxWdgTxt: [6, 8, WeapyStart, WeapyStart+1], boxWdg2: [6, 8, WeapyStart+1, WeapyStart+2], boxWdg3: [6, 8, WeapyStart+2, WeapyStart+3], 
            boxWdg4: [6, 8, WeapyStart+3, WeapyStart+4], boxWdg5: [6, 8, WeapyStart+4, WeapyStart+5], boxWdg6: [6, 8, WeapyStart+5, WeapyStart+6],
            
            boxPon1: [8, 9, 33, 34], boxPon2: [8, 9, 34, 35], boxPon3: [8, 9, 35,36], boxPon4: [8, 9, 36,37], boxPon5: [8, 9, 37,38], boxPon6: [8, 9, 38,39],
            boxPotTxt: [1, 9, 32, 33], boxPot1: [1, 9, 33,34], boxPot2: [1, 9, 34,35], boxPot3: [1, 9, 35,36], boxPot4: [1, 9, 36,37], boxPot5: [1, 9, 37,38], boxPot6: [1, 9, 38,39],

            boxMagTxt: [1, 9, 39, 40], boxMag2: [1, 9, 40, 41], boxMag3: [1, 9, 41, 42], boxMag4: [1, 9, 42, 43], boxMag5: [1, 9, 43, 44], boxMag6: [1, 9, 44, 45],
            boxOthTxt: [1, 9, 45, 46], boxOth2: [1, 9, 46, 47], boxOth3: [1, 9, 47, 48], boxOth4: [1, 9, 48, 49], boxOth5: [1, 9, 49, 50], boxOth6: [1, 9, 50, 51],
            boxFolTxt: [1, 9, 51, 52], boxFol1: [1, 9, 52, 53], boxFol2: [1, 9, 53, 54],
            boxRacTxt: [7, 9, SpellStart-8, SpellStart-7], boxRac1: [1, 9, SpellStart-8, SpellStart],
            boxSavTxt: [1, 9, SavyStart, SavyStart+1], boxSav1: [1, 5, SavyStart+1, SavyStart+4], boxSav2: [5, 9, SavyStart+1, SavyStart+4],
            boxAbiTxt: [5, 9, SpellStart+22, SpellStart+23]
        }
        
        // Boxes for spells
        for (let col = 1; col <= 5; col++) {

            let colShift = 1
            let rowShift = 0

            if ( col > 2 ) { 
                colShift = 3;
                rowShift = 11;
             }
            if ( col > 4 ) { 
                colShift = 5;
                rowShift = 22;
             }
            
            boxes_temp['boxSpt' + col ] = [1 + (col - colShift) * 4, 3 + (col - colShift) * 4, SpellStart + rowShift, SpellStart+1 + rowShift];
            boxes_temp['boxSpq1' + col ] = [3 + (col - colShift) * 4, 4 + (col - colShift) * 4, SpellStart+ rowShift, SpellStart+1 + rowShift];
            boxes_temp['boxSpq2' + col ] = [4 + (col - colShift) * 4, 5 + (col - colShift) * 4, SpellStart+ rowShift, SpellStart+1 + rowShift];
            
            for (let row = 1; row <= 10; row++) {
                if ( col === 5 & row > 6) continue; // the final column has "More" insead of spells
                boxes_temp['boxS' + col + row] = [1 + (col - colShift) * 4, 5 + (col - colShift) * 4, row + SpellStart + rowShift, row + SpellStart + 1 +rowShift];
            }
        }
        
        return boxes_temp
    }


// -----------------------------------------------------        
//                     RETURN JSX 
// -----------------------------------------------------

    return (
        <>
        <CharNameMobile {...props} charID='charMobile' data={data} toggleCollapse={toggleCollapse}/>
        {collapsed ? null :
        <div class="charsheet-scroll">
            {activeView === 'charsheet' ?
                <>
                <div id={"charsheet-"+thisCharID} className="charsheetMobile">

                    <FlexiGrid2
                        rowSize = '8px'
                        colSize = '36px'
                        id = {thisCharID+'-grid-full'}
                        classRoot = 'cf'
                        cells = { cells_layout_main }
                        cellsHTML = { cells_html }
                        data = { data }
                        onDataChange = { handleDataChange }
                        boxes = { boxez() }
                        globalState = { props.state}
                    />

                    <LoadSaveButton className='no-print loadbutton-mobile' state={[data, setData, data.name, setChar ]} spellCheckArray={spellCheckArray} isDirty={isDirty} setIsDirty={setIsDirty}/>

                </div>
                    
                </>
            :
                <Spellbook state={globalState} {...props} />
            }
        </div>
    }
        </>
    )

    };  // end of function

    export default CharsheetMobile

/*

Common user: MobileDataPage.js
            <CharsheetMobile 
                state={ props.state } charID='charMobile' data={ char0data } setdata={ setChar0Data } 
                spellCheckArray={spellCheckArray} tempCharDataArray={tempCharDataArray} 
                activeViewArray={props.activeViewArray}
            />
      
*/